import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { timeout, catchError, map} from 'rxjs/operators';
import { throwError } from 'rxjs'

import { Router } from '@angular/router';
import { SuccessResponse, ErrorResponse } from '../interfases/responses.interfases';

import { SocialService } from './social.service';

import Swal from 'sweetalert2';






@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {


  constructor(
        private router:Router,
        private http:HttpClient,
        private socialService:SocialService,
        ) { }
    

    validateErrorResponse(error:ErrorResponse, forzar?){
        console.error(error)

        switch(error.text){
            case 'INVALID_DEVICE':
                localStorage.removeItem('moveup_device_id');
                break;
            case 'SOCIAL_ACCOUNT_NOT_LINKED':
                Swal.close();
                Swal.fire('Cuenta inexistente', 'No existe ninguna cuenta vinculada a este medio social. Crea una nueva cuenta', 'info')
                this.socialService.deleteUser();
                
                break;
            case 'USER_EMAIL_ALREADY_EXISTS':
                Swal.close();
                Swal.fire('Email existente', 'Ya existe una cuenta con el email solicitado. Inicia sesión o recupera la contraseña. De lo contrario verifica tu email.', 'info')
                this.socialService.deleteUser();
                break;
            case 'USER_FID_ALREADY_EXISTS':
                Swal.close();
                Swal.fire('Cuenta existente', 'Ya has creado una cuenta con este medio social anteriormente. Inicia sesión en la sección correspondiente.', 'info')
                this.socialService.logout();
                break;
            case 'USER_ALREADY_EXISTS':
                Swal.close();
                Swal.fire('Email existente', 'Ya existe una cuenta con el email solicitado. Inicia sesión o recupera la contraseña. De lo contrario verifica tu email.', 'info')
                this.socialService.logout();
                break;
            default:
                if(forzar){

                    switch(forzar){
                        case 'errorsocialcreate':
                            this.socialService.deleteUser();
                            break;
                        default:
                            console.info('Error: ', error.text)
                            break;
                    }

                }else{
                    console.info('Error: ', error.text)
                }
                break;
        }
    }






}
